import { render, staticRenderFns } from "./HintsSection.vue?vue&type=template&id=71f9882c&scoped=true"
import script from "./HintsSection.vue?vue&type=script&lang=js"
export * from "./HintsSection.vue?vue&type=script&lang=js"
import style0 from "./HintsSection.vue?vue&type=style&index=0&id=71f9882c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f9882c",
  null
  
)

export default component.exports